import styled from 'styled-components';

export default styled.h4`
  margin: 0 0 ${({ theme }) => theme.spacing * 1.5}px 0;
  color: ${({ theme }) => theme.palette.card.title};
  font-weight: 400;
`;
